export default __webpack_public_path__ + "static/media/bed.2f9e5a5b.svg";